import React, { useEffect, useRef } from 'react';
import { CharacterRenderer } from './LoveRunGame/utils/characterRenderer';

interface PixelCharacterProps {
    character: 'julia' | 'ben';
    size?: number;
    isRunning?: boolean;
    runningTime?: number;
}

const PixelCharacter: React.FC<PixelCharacterProps> = ({ character, size = 48, isRunning = false, runningTime = 0 }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        ctx.clearRect(0, 0, size, size);
        if (character === 'julia') {
            CharacterRenderer.drawJulia(ctx, 0, 0, isRunning, runningTime);
        } else {
            CharacterRenderer.drawBen(ctx, 0, 0, isRunning, runningTime);
        }
    }, [character, size, isRunning, runningTime]);

    return (
        <canvas
            ref={canvasRef}
            width={size}
            height={size}
            style={{ width: size, height: size, imageRendering: 'pixelated', background: 'transparent' }}
            aria-label={character}
        />
    );
};

export default PixelCharacter;
